import type { AttentionItem } from '../../domain/types';

export function jiraWorkflowTone(workflow: string): 'ok' | 'bad' | 'warn' | 'accent' {
  if (workflow === 'Done' || workflow === 'Cerrado') return 'ok';
  if (workflow === 'On Hold') return 'bad';
  if (workflow === 'En revisión' || workflow === 'Listo para QA') return 'warn';
  return 'accent';
}

export function jiraAccentStripBackground(item: AttentionItem, workflow: string): string {
  if (workflow === 'Done' || workflow === 'Cerrado') return 'var(--z-ok)';
  if (item.st === 'blocked' || workflow === 'On Hold') {
    return 'repeating-linear-gradient(135deg, var(--z-bad) 0 3px, transparent 3px 6px)';
  }
  return jiraAccentForStatus(item.st);
}

function jiraAccentForStatus(st: AttentionItem['st']): string {
  if (st === 'you') return 'var(--z-warn)';
  if (st === 'ready') return 'repeating-linear-gradient(0deg, var(--z-ok) 0 5px, transparent 5px 6px)';
  return 'var(--z-dim)';
}

export function jiraArticleBackground(isSelected: boolean): string {
  return isSelected ? 'var(--z-accent-wash)' : 'var(--z-surface)';
}

export function jiraArticleShadow(isSelected: boolean): string {
  return isSelected ? '0 4px 16px var(--z-sh-6)' : '0 1px 2px var(--z-sh-4)';
}

export const JIRA_STANDARD_STATUSES = [
  'Tareas por hacer',
  'Planificación',
  'IN DEV',
  'En curso',
  'En revisión',
  'Listo para QA',
  'In QA',
  'Ready for QA',
  'Done',
  'Cerrado',
  'On Hold',
] as const;
